import Hero from "@/components/Hero";
import PreorderHero from "@/components/PreorderHero";
import ProjectsShowcase from "@/components/ProjectsShowcase";
import Marquee from "@/components/Marquee";
import Partnership from "@/components/Partnership";
import Releases from "@/components/Releases";
import ChapterReveal from "@/components/ChapterReveal";
import EditionsComparison from "@/components/EditionsComparison";
import PreorderFAQ from "@/components/PreorderFAQ";
import Newsletter from "@/components/Newsletter";
import Store from "@/components/Store";
import DLC from "@/components/DLC";
import Manifesto from "@/components/Manifesto";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function HomePage({ data }) {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 120);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [hash]);

  return (
    <>
      <Hero data={data} />
      <PreorderHero data={data.preorderNotice} keyArt={data.hero.backgroundImage} />
      <ProjectsShowcase data={data} />
      <Marquee items={data.marquee} />
      <Partnership data={data.xbox} />
      <Releases data={data.releases} />
      <ChapterReveal
        data={data.chapter02}
        sectionId="chapter-02"
        testIdPrefix="chapter-02"
      />
      <ChapterReveal
        data={data.chapter03}
        sectionId="chapter-03"
        testIdPrefix="chapter-03"
      />
      <EditionsComparison data={data.editionsComparison} />
      <PreorderFAQ data={data.faq} />
      <Newsletter data={data.newsletter} />
      <Store data={data.store} countdown={data.countdowns.preorders} />
      <DLC data={data.dlc} />
      <Manifesto data={data.manifesto} />
    </>
  );
}
